import UnlockUsers from "../../components/unlockedUsers/UnlockUsers"

function UnlockedUsersPage() {
    return (
        <>
        <UnlockUsers/>
        </>
    )
}
export default UnlockedUsersPage